import { render } from "./Guild.vue?vue&type=template&id=27e6fa9c"
import script from "./Guild.vue?vue&type=script&lang=js"
export * from "./Guild.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bewinxed/Downloads/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__